import styled from "styled-components";
import { dimensions, colors, typography } from "modules/common/styles";
import { rgba } from "modules/common/styles/color";

const columnSizing = "20px";
const borderRadius = "2px";
const rowTitleSize = 230;
const boxSize = 150;
const boxSize1 = 155;
const columnTitleSize = 300;
const unitSpace = `${dimensions.unitSpacing}px`;

const colorsCode = ["#ff0000", "#00ff00", "#0000ff"];
const random_color = colorsCode[Math.floor(Math.random() * colorsCode.length)];

const FullContent = styled.div`
  @media (max-width: 760px) {
    display: block;
  }
  flex: 1;
  display: flex;
  min-height: 100%;
  justify-content: ${(props) => props.center && "center"};
  align-items: center;
`;

const BoxRoot = styled.div`
  text-align: center;
  float: left;
  background: ${colors.colorLightBlue};
  box-shadow: ${(props) =>
    props.selected
      ? `0 10px 20px ${rgba(colors.colorCoreDarkGray, 0.12)}`
      : `0 6px 10px 1px ${rgba(colors.colorCoreGray, 0.08)}`};
  margin-right: ${dimensions.coreSpacing}px;
  margin-bottom: ${dimensions.coreSpacing}px;
  border-radius: ${dimensions.unitSpacing / 2 - 1}px;
  transition: all 0.25s ease;
  border: 1px solid
    ${(props) =>
      props.selected ? colors.colorSecondary : colors.borderPrimary};

  > a {
    display: block;
    padding: ${dimensions.coreSpacing}px;
    text-decoration: none;

    &:focus {
      text-decoration: none;
    }
  }

  img {
    width: 83px;
    transition: all 0.5s ease;
  }

  span {
    color: ${colors.colorCoreGray};
    display: block;
    margin-top: ${dimensions.unitSpacing}px;
  }

  &:hover {
    cursor: pointer;
    box-shadow: 0 10px 20px ${rgba(colors.colorCoreDarkGray, 0.12)};

    span {
      font-weight: 500;
    }

    img {
      transform: scale(1.1);
    }
  }

  @media (max-width: 780px) {
    width: 100%;
    margin-right: 15px;
  }
`;
const InfoWrapper = styled.div`
  // padding: 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  .name {
    flex: 1;
    word-break: break-word;
  }

  i {
    transition: all 0.3s ease;
    color: ${colors.colorCoreLightGray};

    &:hover {
      cursor: pointer;
      color: ${colors.colorCoreGray};
    }
  }
`;

const InfoWrapperP = styled.div`
  text-align: left;
  letter-spacing: 0.32px;
  color: #262626;
  opacity: 1;
  font-size: 14px;
  text-transform: none;
  font-weight: 400;
  margin-top: 6px;
  line-height: 18px;
`;

const ModalButtonDesign = styled.div`
  margin-bottom: 20px;
  width: 100%;
  text-align: center;
  margin-top: 10px;

  button {
    width: 100%;
    border: 0.800000011920929px solid #dae0e6;
    border-radius: 5px;
    background: #faf8ff;
    color: #131313;

    &:hover {
      color: #131313;
    }
  }
`;

const Links = styled.div`
  margin-top: 5px;

  a {
    color: ${colors.colorCoreLightGray};
    margin-right: 10px;

    &:hover {
      color: ${colors.colorCoreGray};
    }

    i {
      font-size: 14px;
    }
  }
`;

const FormWrapper = styled.div`
  display: flex;

  img {
    display: block;
    width: 100px;
    height: 100px;
    border-radius: 50px;
  }
`;

const FormColumn = styled.div`
  flex: 1;
  padding-right: 40px;
  position: relative;

  &:last-of-type {
    padding: 0;
  }
`;

const ColumnTitle = styled.h4`
  text-transform: uppercase;
  font-weight: ${typography.fontWeightMedium};
  border-bottom: 1px dotted ${colors.colorShadowGray};
  padding: ${dimensions.unitSpacing}px 0;
  font-size: 14px;
  margin: ${dimensions.unitSpacing}px 0 ${dimensions.coreSpacing}px 0;
`;

const ModalFooter = styled.div`
  // text-align: right;
  margin-top: 20px;
  // margin-bottom: 15px;
  // margin-top: 40px;
  // position: fixed;
  // bottom: 0;
  // padding: 15px 0;
  // width: 92%;
  // background: #fff;
  position: fixed;
    bottom: 0;
    padding: 23px 30px;
    width: 90%;
    background: #ffffff;
    border-radius: 0px 0px 10px 10px;
    width: 100%;
    left: 0px;
  // margin-top: ${(props) => (props.modalType == "right" ? "40px" : "")};
  // text-align: ${(props) => (props.modalType == "right" ? "right" : "")};
  // position: ${(props) => (props.modalType == "right" ? "fixed" : "")};
  // bottom: ${(props) => (props.modalType == "right" ? "0" : "")};
  // padding: ${(props) => (props.modalType == "right" ? "15px 0px" : "")};
  // width: ${(props) => (props.modalType == "right" ? "92%" : "")};
  // background: ${(props) => (props.modalType == "right" ? "#fff" : "")};
`;

const CenterContent = styled.div`
  text-align: center;
  margin-top: 10px;
`;

const ActivityContent = styled.div`
  position: relative;
  height: ${(props) => props.isEmpty && "360px"};
`;

const Well = styled.div`
  min-height: ${dimensions.coreSpacing}px;
  padding: ${dimensions.unitSpacing}px ${dimensions.coreSpacing}px;
  margin-bottom: ${dimensions.coreSpacing}px;
  background-color: ${colors.bgActive};
  border-left: 2px solid ${colors.colorSecondary};
`;

const DropIcon = styled.span`
  &:after {
    cursor: pointer;
    content: "\\e827";
    font-family: "erxes";
    float: right;
    transition: all ease 0.3s;
    margin-left: ${dimensions.unitSpacing}px;
    transform: ${(props) => props.isOpen && `rotate(180deg)`};
  }
`;

const CloseModal = styled.div`
  position: absolute;
  right: -40px;
  width: 30px;
  height: 30px;
  background: ${rgba(colors.colorBlack, 0.3)};
  line-height: 30px;
  border-radius: 15px;
  text-align: center;
  color: ${colors.colorWhite};

  &:hover {
    background: ${rgba(colors.colorBlack, 0.4)};
    cursor: pointer;
  }

  @media screen and (max-width: 1092px) {
    right: 10px;
    top: 10px;
  }
`;
// const SimpleButton = { isActive?: boolean }(styled.div)`
const SimpleButton = styled.div`
  font-size: 15px;
  background: ${(props) => props.isActive && colors.bgGray};
  width: 24px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  border-radius: 2px;
  transition: background ease 0.3s;

  &:hover {
    background: ${colors.bgActive};
    cursor: pointer;
  }
`;

const Columns = styled.div`
  display: flex;
  flex-direction: row;
  height: 100%;
`;

const Column = styled.div`
  flex: 4;
  position: relative;
  overflow: hidden;

  > input {
    margin-bottom: ${columnSizing};
  }

  ul {
    height: 40vh;
    overflow: auto;
    padding: 0;
    margin: 0;
    list-style-type: none;

    li {
      padding: 6px 40px 6px ${columnSizing};
      position: relative;
      margin-bottom: 6px;
      border: 1px solid ${colors.borderDarker};
      border-radius: ${borderRadius};
      transition: all 0.3s ease;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;

      > i {
        position: absolute;
        right: -1px;
        top: -1px;
        bottom: -1px;
        width: 0;
        overflow: hidden;
        align-items: center;
        justify-content: center;
        display: flex;
        background: ${colors.themeBlue};
        border-radius: ${borderRadius};
        color: ${colors.colorWhite};
        transition: all 0.3s ease;
      }

      &:hover {
        cursor: pointer;
        background: ${colors.bgActive};

        > i {
          width: 34px;
        }
      }
    }
  }

  &:last-of-type {
    flex: 3;
    margin-left: ${columnSizing};
    padding-left: ${columnSizing};
    border-left: 1px solid ${colors.borderDarker};

    li {
      font-weight: bold;

      > i {
        background: ${colors.colorCoreRed};
      }
    }
  }

  &.multiple:first-child {
    margin-right: ${columnSizing};
  }
`;

const DataWrapperClass = styled.div`
  section.sc-iELTvK.dgWnOn {
    background: #fff;
    margin-left: 20px;
    margin-right: 20px;
  }
  section.sc-jtRfpW.daxgFZ {
    margin-right: 20px;
  }
  section.sc-iELTvK.dstvIj {
    background: #fff;
    margin-left: 20px;
  }
  @media screen and (max-width: 780px) {
    // margin-left: -21px;
    // margin-right: -3px;
  }
`;
const OverflowClass = styled.div`
  overflow: auto;
  min-height: 300px;

  @media screen and (max-width: 780px) {
    overflow: auto;
  }
`;

const Title = styled.h4`
  margin: 0 0 ${columnSizing} 0;
  background: ${colors.bgActive};
  padding: 10px ${columnSizing};
  white-space: ${(props) => (props.full ? "normal" : "nowrap")};
  font-size: 12px;
  text-transform: uppercase;
  overflow: hidden;
  text-overflow: ellipsis;

  span {
    opacity: 0.7;
    margin-left: 10px;
  }
`;

const RowTitle = styled.h3`
  font-size: ${typography.fontSizeHeading8 + 3}px;
  font-weight: ${typography.fontWeightMedium};
  text-transform: uppercase;
  margin: 0 0 ${dimensions.coreSpacing}px;
  color: ${colors.colorCoreDarkGray};
  flex-shrink: 0;
  align-self: center;
  width: ${columnTitleSize}px;

  > span {
    text-transform: initial;
    display: block;
    color: ${colors.colorCoreGray};
    margin-top: ${dimensions.unitSpacing - 5}px;
    font-weight: normal;
    max-width: ${columnTitleSize - 40}px;
    line-height: 1.4;
  }

  @media (max-width: 1170px) {
    align-self: flex-start;
  }
`;

const Box = styled(BoxRoot)`
  width: ${boxSize}px;
  height: ${boxSize1}px;
  // border-color: transparent;
  background: ${colors.colorWhite};
  position: relative;
  border: 1px solid #e0dede;
  box-shadow: 0px 10px 25px 0px #0000000d;
  border-radius: 25px;

  @media (max-width: 768px) {
    width: 105px;
    height: auto;
  }

  img {
    height: 60px;
    width: 60px;
    margin-top: 8px;
    // background: #F1F7FF;
    // padding: 12px;
    // border-radius: 50%;

    @media (max-width: 768px) {
      margin-top: 5px;
    }
  }

  > a {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    height: 100%;

    > em {
      background: ${colors.colorCoreGreen};
      border-radius: 3px;
      color: #fff;
      font-size: 11px;
      font-weight: 600;
      padding: 0 ${dimensions.unitSpacing - 5}px;
      position: absolute;
      right: ${dimensions.unitSpacing - 5}px;
      top: ${dimensions.unitSpacing - 5}px;
      text-transform: uppercase;
    }

    &:focus {
      text-decoration: none;
    }
  }

  &.hasBorder {
    border-bottom: ${dimensions.unitSpacing - 7}px solid
      ${colors.colorCoreGreen};
  }

  &:hover {
    img {
      transform: scale(1.1) rotate(4deg);
    }
  }
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  padding-top: ${dimensions.coreSpacing}px;
`;

const BoxName = styled.span`
  color: #303030 !important;
  display: block;
  margin-top: ${dimensions.unitSpacing}px;
  font-size: 15px;
  font-weight: 500;
  line-height: 21px;
`;

const AuthTextBox = styled.div`
  margin: auto;
  background: #fff;
  width: 214px;
  height: 72px;
  /* position: absolute; */
  border-radius: 50px;
  padding-top: 14px;
  // box-shadow: 0px 12px 25px rgba(0, 0, 0, 0.1);
  h2 {
    color: #023372;
    font-size: 22px;
    font-weight: 500;
    margin: 0px;
    text-align: center;
  }
`;

const AuthBox = styled.div`
  background-color: ${colors.colorWhite};
  padding: 40px 50px;
  // box-shadow: 0px 12px 25px rgba(0, 0, 0, 0.1);
  border-radius: 30px;
  text-align: center;
  // margin-top: -40px;

  .otp {
    width: 46%;
    margin: auto;
  }

  .otp .sc-gipzik.fNpEJH {
    padding-right: 9px;
    margin-top: 15px;
    padding-left: 9px;
  }

  h2 {
    color: #023372;
    font-size: 18px;
    font-weight: 500;
    margin: 0 0 45px;
  }

  p {
    letter-spacing: 0.48px;
    color: #626262;
    font-weight: 600;
    font-size: 16px;
    margin-bottom: 30px;
  }

  label {
    font-size: 13px;
    font-weight: 500;
    letter-spacing: 0.26px;
    // color: #242424;
  }

  input {
    padding: 0 16px 0px;
    color: ${colors.colorCoreBlack};
    font-size: 12px;
    outline: 0;
    // background: #FAF8FF;
    border: 0.800000011920929px solid #dae0e6;
    border-radius: 5px;

    &:focus {
      outline: 0;
      box-shadow: none;
      border-color: ${colors.colorPrimary};
      background: #faf8ff;
    }

    input:-internal-autofill-selected {
      background: none;
    }
  }

  button {
    // text-transform: uppercase;
    // // font-weight: 600;
    // margin-top: 50px;
    border: 0;
    // box-shadow: 0px 10px 20px rgba(2, 51, 114, 0.2);
    border-radius: 9px;
    padding: 8px 22px;
  }

  .line {
    width: 100%;
    text-align: center;
    border-bottom: 1px solid #f0f1ff;
    line-height: 0.1em;
    margin: 35px;
    margin-bottom: 40px;
    margin-left: 0%;
  }

  .line span {
    background: #fff;
    padding: 0 10px;
    color: #afafb5;
    font-size: 14px;
  }
`;

const InsightContent = styled.div`
  /* background: #EDF1F5; */
  // overflow: auto;

  .summ h5 {
    margin-left: 20px;
  }
`;

const InsightRow = styled.div`
  position: relative;
  // margin-bottom: 24px;

  div {
    margin: 0px;
  }
  .titleCard h5 {
    padding: 0;
    margin: 0;
  }
`;

const ChartWrapper = styled.div`
  padding: ${dimensions.coreSpacing}px;
  border: 1px solid ${colors.borderPrimary};
  border-radius: 10px;
  background: ${colors.colorWhite};
  width: 100%;
  height: ${(props) => (props.height ? `${props.height}px` : "375px")}
  position: relative;
  overflow: auto;
  tbody tr th {
    color: #303030 !imporatant;
  }

  @media (max-width: 768px) {
    height: auto !important;
    margin-bottom: 20px !important;
  }
`;
const OverviewChartWrapper = styled.div`
  padding: 8px 12px;
  border: 1px solid ${colors.borderPrimary};
  border-radius: 10px;
  background: ${colors.colorWhite};
  width: 250px;
  height: ${props => (props.height ? `${props.height}px` : '40vh')}
  position: relative;
  overflow: auto;
  tbody tr th {
    color: #303030 !imporatant;
  }

  @media (max-width: 768px) {
    padding: 15px;
    height: auto !important;
    margin-bottom: 20px !important;
  }
`;

const LoaderWrapper = ChartWrapper.extend`
  padding: ${dimensions.coreSpacing * 2}px;
`;
const SmsStatusDiv = styled.div`
  min-width: 315px;
  margin-bottom: 5px;
  @media (max-width: 568px) {
    min-width: 275px;
  }
`;
const SummaryItem = styled.div`
  // text-align: center;
  border-radius: 10px;
  padding: 20px 20px 20px 20px;
  background-color: ${colors.colorWhite};
  box-shadow: 0px 3px 4px #00000029;

  i {
    color: #4d528e;
    width: 40px;
    height: 40px;
    background: #eaecff;
    text-align: center;
    border-radius: 50px;
    padding-top: 14px;
    float: right;
    margin-right: 11px;
    margin-top: 10px;
  }

  .progress {
    height: 5px;
    margin-top: 10px;
  }

  .progress-bar {
    width: 25%;
    height: 5px;
    background: ${colors.colorPrimary};
  }
`;
const SummaryIcon = styled.div`
  // color:  ${colors.colorWhite};
  // width: 40px;
  // height: 40px;
  // background: #cfd2f7;
  // text-align: center;
  // border-radius: 50px;
  // padding-top: 15px;
  // float: right;
  // // margin-right: 9px;
  margin-top: 7px;
`;
const SummaryTitle = styled.div`
  margin-top: 5px;
  font-size: 16px;
  font-weight: 500;
  // text-transform: uppercase;
`;

const SummaryCount = styled.span`
  font-weight: bold;
  font-size: ${typography.fontSizeHeading5}px;
`;

const FlexRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 12px;
  gap: ${(props) => props.gap}; /* Access gap prop */

  @media (max-width: 768px) {
    display: block;
  }
`;

const InsightTitle = styled.h5`
  text-transform: uppercase;
  font-weight: ${typography.fontWeightRegular};
  padding: ${dimensions.unitSpacing}px 0;
  // margin: ${dimensions.coreSpacing}px 0 ${dimensions.unitSpacing}px;
  font-weight: 700;
  color: ${colors.themeBlack}

  span {
    margin-left: ${dimensions.unitSpacing}px;
  }
`;

const StatusItem = styled.div`
  // border-radius: 10px;
  // padding: 20px 20px 20px 20px;
  // background-color: ${colors.colorWhite};
  // box-shadow: 0px 3px 4px #00000029;

  img {
    // color: #4d528e;
    width: 50px;
    height: auto;
    // background: #eaecff;
    text-align: center;
    // border-radius: 50px;
    // padding-top: 14px;
    float: left;
    margin-right: 11px;
    margin-top: 8px;
  }
`;

const StatusCount = styled.div`
  font-weight: bold;
  font-size: ${typography.fontSizeHeading5}px;
`;

const StatusTitle = styled.div`
  font-weight: 500;
  color: #b8b8b8;
  font-size: 14px;
`;

const Group = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  margin-bottom: 10px;
  // border-left: 3px solid;
  border-radius: 2px;
`;

const Label = styled.div`
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  text-align: left;
  letter-spacing: 0.03em;
  color: #d2d2d2;
`;

const Value = styled.div`
  font-weight: 500;
  font-size: 12px;
  line-height: 21px;
  text-align: right;
  letter-spacing: 0.03em;
  color: #d2d2d2;
`;

const InboundCall = styled.div`
  border-left: 4px solid #fb6a6a;
  margin-bottom: 13px !important;
  border-radius: 2px;
  padding: 3px;
`;

const AreaInner = styled.div`
  padding: 0px 15px 0px 15px;
  display: flex;
  white-space: nowrap;
  align-items: center;

  h5 {
    margin: 0px;
  }

  span {
    color: #a6a6a6;
    font-weight: 500;
    font-size: 13px;
    line-height: 21px;
    width: 100%;
    text-align: right;
  }
`;

const OutboundCall = styled.div`
  border-left: 4px solid #10da24;
  margin-bottom: 20px !important;
  border-radius: 2px;
  padding: 3px;
`;

const HeadingSpan = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 7px;

  h5 {
    padding-top: 0px;
    padding-left: 20px;
    margin-top: 20px;
    // width: 100%;
    padding-right: 20px;
  }
`;

const TotalCallItem = styled.div`
  .loadImg {
    width: 22px;
    height: 22px;
  }

  @media (max-width: 768px) {
    // margin-right: 4px !important;
    margin-bottom: 20px !important;
  }
`;

const ClassForMargin = styled.div`
  @media (max-width: 768px) {
    .col-sm-11 {
      margin-right: 20px;
      margin-left: 20px;
    }
  }
`;

const ClassForPadding = styled.div`
  @media (max-width: 768px) {
    .col-sm-2 {
      // padding-right: 15px !important;
      // margin-bottom: 10px !important;
    }
  }
`;

const TotalCallTitle = styled.div`
  // float: left;
  margin-right: 8px !important;
  color: #303030;
  font-weight: 500;
  font-size: 15px;
  line-height: 36px;
`;

const TotalCallCount = styled.div`
  font-weight: 400;
  font-size: 40px;
  line-height: 42px;
`;

const NonProClass = styled.div`
  section {
    margin-left: -30px;
    margin-right: 0px;
  }
`;

const SummaryNonItem = styled.div`
  display: flex;
  align-items: center;

  span {
    width: 100%;
    text-align: end;
  }
`;

const SummaryNonTitle = styled.div`
  font-size: 14px;
  font-weight: 500;
`;

const SummaryNonCount = styled.div`
  font-size: 18px;
  font-weight: 700;
`;

const StateData = styled.div`
  display: flex;
  align-items: center;
  padding: 7px 0px;
  background: #fff;
  border-radius: 20px;
  padding: 20px;
`;

const CircleShape = styled.div`
  width: 16px;
  height: 16px;
  background: #5e35b1;
  border-radius: 198.954px;
`;

const CircleShapes = styled.div`
  width: 14px;
  height: 14px;
  background: #4879f5;
  border-radius: 50px;
  margin-right: 10px;
`;

const LineShape = styled.div`
  width: 5px;
  height: 25px;
  background: #d84315;
  border-radius: 7.5px;
  margin-right: 10px;
`;

const TextData = styled.div`
  font-size: 14px;
  font-weight: 500;
  text-transform: capitalize;
  // padding-left: 10px;
  // margin-right: 53px;
  position: relative;

  &::after {
    position: absolute;
    content: "";
    background-color: #d84315;
    border-radius: 7.5px;
    left: -10px;
    width: 5px;
    height: 22px;
    top: 0px;
  }
`;

const TextDataa = styled.div`
  font-size: 14px;
  font-weight: 500;
  text-transform: capitalize;
  // padding-left: 10px;
  // margin-right: 53px;
`;

const CountData = styled.div`
  font-size: 16px;
  font-weight: 700;
  margin: 0 0 0 auto !important;
  // padding-right: 10px;
`;

const FlexItem = styled.div`
  @media (max-width: 760px) {
    margin-left: 0px;
    margin-bottom: 10px;
  }
  flex: 1;
  margin: 0;
  margin-left: ${dimensions.coreSpacing}px;

  &:first-child {
    margin-left: 0;
  }

  .form-control {
    box-shadow: none;
    border-radius: 4px;
    border: 1px solid ${colors.themeBlue};
    background: none;
    /* border-bottom: 1px solid ${colors.colorShadowGray}; */
    padding: 7px 14px;
    font-size: 13px;
    height:50px;
    /* box-shadow: none;
    border-radius: 0;
    border: none;
    background: none;
    border-bottom: 1px solid ${colors.colorShadowGray};
    padding: 17px 14px;
    font-size: ${typography.fontSizeBody}px; */

    &:focus {
      box-shadow: none;
      border-color: ${colors.colorPrimary};
    }
  }
`;

const ItemSearch = styled.div`
  input {
    border-left: none;
    border-right: none;
    border-top: none;
    height: 34px;
    padding: 10px;
    border-radius: 0px;
  }
`;

const InsightFilter = styled.div`
  padding: 10px 20px;
  // border-bottom: 1px solid ${colors.borderPrimary};
  background: ${colors.colorWhite};
  border-radius: 20px;

  h5 {
    margin-top: 0;
  }
`;

const InlineItems = styled.div`
  display: flex;
  margin-bottom: ${unitSpace};
  align-items: center;
  justify-content: space-between;

  > div {
    margin-right: ${unitSpace};
  }
`;

const TagsStyle = styled.div`
  border-radius: 14px;
  padding: 3px 9px;
  text-transform: uppercase;
  white-space: nowrap;
  font-size: 11px;
  display: inline-block;
  line-height: 1.32857;
  // background: #ebe2fe;
  margin-right: 5px;
  // color: ${colors.themeBlue};
  border: none;
  animation: 0s ease 0s 1 normal none running none;
`;

const AvtarImg = styled.div`
  display: inline-block;
  // width: 80px;
  // height: 80px;
  position: relative;
  margin-right: 15px;
  img {
    width: 50px;
    // height: 100%;
    // display: inline-block;
    // border-radius: 50%;
  }
  span {
    position: absolute;
    top: auto;
    bottom: 5px;
    right: 0px;
    background: #0161ed;
    border-radius: 50%;
    width: 25px;
    height: 25px;
    line-height: 26px;
    text-align: center;

    i {
      color: #fff;
    }
  }
`;

const ProfileDiv = styled.div`
  display: flex;
  align-items: center;
  padding: 20px;
  white-space: nowrap;

  span {
    float: right;
    margin-left: 20px;
    width: 100%;
    text-align: end;

    i {
      background: #ddd;
      border-radius: 5px;
      padding: 4px 6px 4px 6px;
    }
  }
`;

const UserName = styled.div`
  color: #303030;
  font-weight: 600;
  font-size: 18px;
  line-height: 27px;

  span {
    color: #a6a6a6;
    display: block;
    font-size: 14px;
    font-weight: 500;
    line-height: 21px;
  }
`;

const ClipText = styled.div`
  div {
    max-width: 230px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

const SidebarBox = styled.div`
  border-radius: 10px;
  background: #ffffff;
  padding: 10px;
  margin: 20px;
  height: 90vh;
`;

const Header = styled.div`
  color: #000000;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  background: #f5f7f9;
  padding: 12px 20px;
  margin-bottom: 15px;
`;

const Body = styled.div`
  max-height: 60vh;
  overflow-y: auto;
  margin: 0px;
`;
const BodyDiv = styled.div`
  padding: 4px 15px;

  .title {
    text-transform: capitalize;
    font-size: 13px;
    line-height: 18px;
  }

  .text {
    color: #000000;
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    padding: 0px 0px 5px 0px;
    text-transform: capitalize;
  }
`;

const CustomTabs = styled.div`
  .nav-tabs {
    padding 5px 10px 0px;
  }
  .nav-tabs > li.active > a {
    border-bottom: 3px solid #2222FF;
    border-top: none;
    border-right: none;
    border-left: none;
    color: #303030;
  }
  .nav-tabs > li > a {
    color: #878582;
    outline: none;
    border-top: none;
    border-right: none;
    border-left: none;
    border-bottom: none;
  }
  .nav > li > a:focus,
  .nav > li > a:hover {
    //  border-color: transparent;
    background-color: transparent;
  }
`;

const Timeline = styled.div`
  padding-left: 30px;
  position: relative;

  .rs-timeline {
    direction: ltr;
    list-style: none;
    margin-bottom: 0;
    padding: 0;
  }

  .rs-timeline-align-left .rs-timeline-item {
    padding-left: 22px;
  }

  .rs-timeline-item {
    position: relative;
    text-align: left;
    margin-right: 20px;
  }

  .rs-timeline-item:first-child .rs-timeline-item-tail {
    top: 5px;
  }

  .rs-timeline-align-left .rs-timeline-item-tail {
    left: 4px;
  }

  .rs-timeline-item-tail {
    background-color: #d9d9d9;
    bottom: 0;
    position: absolute;
    top: 0;
    width: 2px;
  }

  .rs-timeline-align-left .rs-timeline-item-dot {
    left: 0;
  }

  .rs-timeline-item-dot {
    position: absolute;
    top: 5px;
  }

  .rs-timeline-item-dot:before {
    background-color: ${random_color};
    border-radius: 50%;
    content: "";
    display: block;
    height: 10px;
    width: 10px;
  }

  .rs-timeline-item:not(:last-child) .rs-timeline-item-content {
    padding-bottom: 15px;
  }

  .rs-timeline-item:last-child .rs-timeline-item-dot:before {
    background-color: #66cd2e;
  }

  .rs-timeline-item:last-child .rs-timeline-item-tail {
    bottom: auto;
    height: 15px;
  }

  .date {
    color: #303030;
    font-weight: 500;
    font-size: 14px;
    line-height: 21px;
    margin-right: 20px;
  }

  // .title {
  //   color: #A6A6A6;
  //   font-weight: 600;
  //   font-size: 14px;
  //   line-height: 21px;
  // }

  // .desc {
  //   font-weight: 400;
  //   font-size: 14px;
  //   line-height: 21px;
  //   letter-spacing: 0.03em;
  //   color: #303030;
  // }

  // .time {
  //   color: #A6A6A6;
  //   font-weight: 400;
  //   font-size: 14px;
  //   line-height: 21px;
  //   letter-spacing: 0.03em;
  // }
`;

const ActivityTitle = styled.h4`
  margin: 0;
  padding: ${dimensions.coreSpacing * 1.5}px 0 ${dimensions.coreSpacing}px;
  font-weight: 400;
  color: ${colors.textPrimary};
`;

const TitleAgent = styled.div`
  font-size: 14px;
  color: #303030;
  // padding-left: 40px;
  // padding-top: 18px;
  // margin-right: 10px;
  // margin-bottom: -15px;

  span {
    font-weight: 700;
  }
`;

const FilterOption = styled.div`
  border: 1px solid #30303066;
  box-shadow: 0px 6px 8px 0px #0000000f;
  width: 178px;
  height: 51px;
  background: #ffffff;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: space-evenly;

  div {
    display: flex;
    align-items: center;
    font-weight: 400;
    letter-spacing: 0.05em;
    font-size: 14px;
    cursor: pointer;
    color: #acacac;

    path {
      stroke: #acacac;
    }

    &:hover,
    &:active {
      color: ${colors.themeBlue};
      font-weight: 600;

      path {
        stroke: ${colors.themeBlue};
      }
    }
  }

  span {
    margin-left: 5px;
  }
`;

const UserInfo = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 6px;

  img {
    width: 24px;
    height: 24px;
    border-radius: 50px;
    margin-right: 7px;
  }

  h6 {
    font-weight: 500;
    font-size: 14px;
    margin: 0px;
  }

  span {
    font-weight: 600;
    font-size: 14px;
    margin-left: 7px;
  }

  .time {
    width: 100%;
    text-align: right;
    color: #a6a6a6;
    font-weight: 500;
  }
`;

const UserTag = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 6px;

  span {
    font-weight: 400;
    font-size: 14px;
    color: #303030;
    letter-spacing: 0.03em;
    line-height: 21px;
    margin-right: 7px;
  }
`;

const UserNote = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 6px;

  span {
    font-weight: 400;
    font-size: 14px;
    color: #303030;
    letter-spacing: 0.03em;
    line-height: 21px;
    margin-right: 7px;
  }

  h6 {
    margin: 0;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    letter-spacing: 0.03em;
    color: #303030;
  }

  h5 {
    margin: 0;
    font-weight: 500;
    font-size: 14px;
    line-height: 21px;
    letter-spacing: 0.03em;
    color: #303030;
    width: 100%;
    text-align: right;
    cursor: pointer;
  }
`;

const StateDataAgent = styled.div`
  display: flex;
  align-items: center;
  padding: 7px 0px;
`;

const ComponentBox = styled.div`
  background: #fff;
  height: calc(100vh - 190px);
  overflow: auto;
  padding: 20px;
`;

const DateView = styled.div`
  display: flex;
  align-items: center;
  white-space: nowrap;

  .date {
    color: #303030;
    font-weight: 500;
    font-size: 16px;
    line-height: 21px;
    margin-right: 20px;
    letter-spacing: 0.8px;
  }

  hr {
    border-top: 0.9px dashed #ddd;
    width: 100%;
  }
`;

const DataViewList = styled.div`
  max-height: 70vh;
  overflow-y: auto;
`;
const DataView = styled.div`
  display: flex;
  // align-items: center;
  white-space: nowrap;
  .time {
    color: #7a7a8a;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    letter-spacing: 0.8px;
    margin-right: 20px;
    margin-top: 20px;
  }
`;

const ContentData = styled.div`
  border: 1px solid #ddd;
  border-radius: 10px;
  padding: 10px;
  width: 100%;
  margin-bottom: 20px;
`;

const BoxData = styled.div`
  display: flex;
  white-space: nowrap;



    // &:before {
    //   background-color: #586874;
    //   width: 5px;
    //   height: 5px;
    //   border-radius: 50px;
    //   top: 0;
    //   left: 0;
    // }
  }
`;

const IconData = styled.div`
  margin-right: 20px;
  margin-top: 10px;
`;

const TagLine = styled.div`
  display: flex;
  align-items: center;

  h6 {
    font-weight: 500;
    font-size: 14px;
    margin: 0px;
    display: flex;
    align-items: center;

    &:after {
      content: '';
      background-color: #586874;
      width: 5px;
      height: 5px;
      border-radius: 50px;
      top: 0;
      display: block;
      margin-left: 7px;
      margin-right: 7px;
  }

  span {
    color: #74818a;
    font-weight: 500;
    font-size: 14px;
  }
`;

const ProgressData = styled.div`
  // overflow-y : auto;
  // height: 120px;
`;

const DescData = styled.div`
  h6 {
    margin-bottom: 0px;
    font-size: 14px;
    font-weight: 600;
    white-space: normal;
    line-height: 1.5;
    letter-spacing: 0.03em;
  }

  div {
    font-size: 14px;
    white-space: normal;
    letter-spacing: 0.03em;
    line-height: 1.5;
  }

  span {
    color: ${colors.themeBlue};
    font-weight: 500;
    margin-left: 5px;
    cursor: pointer;
  }
`;

const ContentDataTheme = styled.div`
  border-radius: 10px;
  padding: 1px;
  // width: 100%;
  margin: 25px 170px;
  background: #fff;
`;

const ToggleArea = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  label {
    margin-left: 10px;
    margin-bottom: 0px;
  }
`;

const SkillWrapper = styled.div`
  max-height: 100%;
  inset: 0px;
  overflow: inherit;
  padding-left: 30px;
  padding-top: 30px;
  margin-right: 30px;
  margin-bottom: 30px;

  h4 {
    color: #303030;
    font-weight: 600;
    font-size: 22px;
    letter-spacing: 0.5px;
  }

  p {
    font-size: 14px;
  }

  .topHead {
    justify-content: space-between;
  }

  .topHead input[type="text"] {
    width: 410px;
    border-radius: 8px;
    padding: 8px 20px;
  }
`;

const TableData = styled.div`
  background: #eee;
  min-height: ${dimensions.headerSpacing}px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  border-bottom: 1px solid #d1cccc;
  display: flex;
  justify-content: space-between;
  padding: 12px;
  // margin-top: 30px;
  // border-radius: 9px;
  align-items: center;

  label {
    color: ${colors.themeBlack};
    margin: 0px;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.5px;
  }
`;

// const SkillWrapper = styled.div`
//   max-height: 100%;
//   inset: 0px;
//   overflow: inherit;
//   padding-left: 30px;
//   padding-top: 30px;
//   margin-right: 30px;
//   margin-bottom: 30px;

// `;

const ShowHide = styled.span`
position: absolute;
top: 7px;
right: 0;
cursor: pointer;
svg{
  width: 20px;
  height: 20px;
  display: flex;
  }
`

export {
  BoxRoot,
  FullContent,
  ModalFooter,
  InfoWrapper,
  //AccountTable,
  Links,
  Well,
  FormWrapper,
  FormColumn,
  ColumnTitle,
  CenterContent,
  ActivityContent,
  DropIcon,
  InfoWrapperP,
  ModalButtonDesign,
  SimpleButton,
  CloseModal,
  DataWrapperClass,
  Title,
  Column,
  Columns,
  Box,
  RowTitle,
  Row,
  BoxName,
  AuthBox,
  AuthTextBox,
  InsightContent,
  InsightRow,
  LoaderWrapper,
  SmsStatusDiv,
  SummaryItem,
  SummaryIcon,
  SummaryTitle,
  SummaryCount,
  ChartWrapper,
  FlexRow,
  InsightTitle,
  StatusItem,
  StatusCount,
  StatusTitle,
  Group,
  Label,
  Value,
  InboundCall,
  AreaInner,
  OutboundCall,
  HeadingSpan,
  TotalCallItem,
  TotalCallTitle,
  TotalCallCount,
  NonProClass,
  SummaryNonItem,
  SummaryNonTitle,
  SummaryNonCount,
  StateData,
  CircleShape,
  TextData,
  TextDataa,
  CountData,
  FlexItem,
  InlineItems,
  InsightFilter,
  ItemSearch,
  TagsStyle,
  AvtarImg,
  ProfileDiv,
  UserName,
  SidebarBox,
  Header,
  Body,
  OverflowClass,
  BodyDiv,
  CustomTabs,
  Timeline,
  ActivityTitle,
  TitleAgent,
  FilterOption,
  UserInfo,
  UserTag,
  UserNote,
  StateDataAgent,
  ComponentBox,
  DateView,
  DataView,
  DataViewList,
  ContentData,
  BoxData,
  IconData,
  TagLine,
  ProgressData,
  DescData,
  LineShape,
  CircleShapes,
  ContentDataTheme,
  ClassForMargin,
  ClassForPadding,
  ToggleArea,
  SkillWrapper,
  TableData,
  OverviewChartWrapper,
  ShowHide
};



// WEBPACK FOOTER //
// ./src/modules/theme/theme1/common/styles/main.js